import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEat = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "local_dining",
		d: "M1.52221 16L0.84938 15.3269L10.4873 5.68904C10.1654 4.9257 10.0952 4.17584 10.2769 3.43945C10.4587 2.70306 10.8678 2.02032 11.5041 1.39124C12.1247 0.770553 12.9013 0.340147 13.8341 0.10002C14.7668 -0.140266 15.5459 0.0523908 16.1714 0.677989C16.7968 1.30343 16.9894 2.08246 16.7491 3.01507C16.509 3.94784 16.0787 4.72449 15.4581 5.34502C14.8289 5.98155 14.1461 6.39064 13.4097 6.57228C12.6733 6.75392 11.9235 6.68378 11.1603 6.36187L9.42287 8.09934L16.6505 15.3269L15.9774 16L8.7498 8.81996L1.52221 16ZM4.4375 7.97857L1.80395 5.34502C1.09434 4.63541 0.71212 3.796 0.657279 2.82677C0.602438 1.85754 0.887104 0.981517 1.51128 0.198687L6.85874 5.55733L4.4375 7.97857Z",
		fill: "currentColor",
		style: {
			fill: "currentColor",
			fillOpacity: 1
		}
	})
});
export default SvgEat;
